import React from 'react';

import launchPointStyles from './AlmeLaunchPoint.styles';

import { withStyles, WithStyles, makeStyles, createStyles } from '@material-ui/core/styles';

import {
    Theme, Accordion, AccordionDetails, AccordionSummary,
    Typography, Container, Box,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { AlmeLaunchPointConfig } from './AlmeLaunchPointConfig';
import AlmeConfigFormControl, { ConfigControlGroups } from '../AlmeConfigFormControl/AlmeConfigFormControl';
import AlmeInputConfigTool from '../AlmeInput/AlmeInputConfigTool';
import { AlmeInputConfig } from '../AlmeInput/AlmeInputConfig';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeLaunchPointConfigToolProps extends WithStyles<typeof launchPointStyles> {
    almeConfig: AlmeLaunchPointConfig;
    onConfigChange: (almeConfig: AlmeLaunchPointConfig) => void;
}

const AlmeLaunchPointConfigTool: React.FC<AlmeLaunchPointConfigToolProps> = (props: AlmeLaunchPointConfigToolProps) => {
    const classes = useStyles();

    const launchPointButtonText = props.almeConfig.launchPoint.buttonText;
    const launchPointInputFieldText = props.almeConfig.launchPoint.inputFieldText;

    const setLaunchPointButtonText = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        almeConfig.launchPoint.buttonText = newValue;
        props.onConfigChange(almeConfig);
    };

    const setLaunchPointInputFieldText = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        almeConfig.launchPoint.inputFieldText = newValue;
        props.onConfigChange(almeConfig);
    };

    const onInputConfigChange = (inputConfig: AlmeInputConfig): void => {
        const launchConfig: AlmeLaunchPointConfig = {
            launchPoint: {
                ...props.almeConfig.launchPoint,
                input: {
                    ...inputConfig.input,
                },
            },
        };
        props.onConfigChange(launchConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'Launch Point Button',
            controlGroups: [
                {
                    id: 'alme-launch-point-button-text-config',
                    label: 'Launch Point Button Text',
                    name: 'launchPointButtonText',
                    value: launchPointButtonText,
                    changeHandler: setLaunchPointButtonText,
                },
                {
                    id: 'alme-launch-point-input-text-config',
                    label: 'Launch Point Input Text',
                    name: 'launchPointInputFieldText',
                    value: launchPointInputFieldText,
                    changeHandler: setLaunchPointInputFieldText,
                },
            ],
        },
    ];

    return (
        <Box className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-alme-launch-point-config-tool-content"
                    id="panel-alme-launch-point-config-tool-header"
                >
                    <Typography variant='h6'>Alme Launch Point Config Tools</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Container>
                        <AlmeConfigFormControl title='Alme Launch Point Config' configControls={configControls} />
                        <AlmeInputConfigTool namePrefix='almeLaunchPoint' idPrefix='alme-launch-point-' almeConfig={props.almeConfig.launchPoint} onConfigChange={onInputConfigChange} />
                    </Container>
                </AccordionDetails>
            </Accordion>
        </Box >
    );
};

export default withStyles(launchPointStyles)(AlmeLaunchPointConfigTool);
